module.exports = __webpack_public_path__ + "static/img/target.09661982.png";